import { InputAdornment } from '@mui/material';
import React, { Fragment, FunctionComponent } from 'react';
import { IconButton } from '../../StyledComponents';
import {Eye, EyeSlash} from 'iconsax-reactjs'

interface IIsVisibleButtonProps {
  isNowVisible?: boolean;
  onClick: () => void;
  isPrimary?: boolean;
}

const IsVisibleButton: FunctionComponent<IIsVisibleButtonProps> = ({ isNowVisible, isPrimary = false, onClick }: IIsVisibleButtonProps) => {
  return (
    <Fragment>
      <InputAdornment position="end" className="password-visiblity-icon">
        <IconButton
          aria-label="toggle password visibility"
          onClick={onClick}
          disableRipple={true}
          disableFocusRipple={true}
          tabIndex={-1}
          size="large">
          {isNowVisible ?
            <EyeSlash color={isPrimary ? '#C6CDD5' : '#292D32'} variant={isPrimary ? "Bold" : ''}/> :
            <Eye color={isPrimary ? '#C6CDD5' : '#292D32'} variant={isPrimary ? "Bold" : ''}/>
          }
        </IconButton>
      </InputAdornment>
    </Fragment>
  );
};

export default IsVisibleButton;
